import { REVIEWS_ACTION_TYPES } from './actionTypes';
import { normalizeItems, mergeNormalizedData } from "../utility";

const initialState = {
    byId: {},

    reviewsByProductId: {
    },

    loading: false,
    error: null,
};

export const reviewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case REVIEWS_ACTION_TYPES.FETCH_LIST_REQUEST: {
            const { productId } = action.payload;
            const currentProductState = state.reviewsByProductId[productId] || {
                ids: [],
                currentPage: 0,
                hasMore: true,
                total: 0
            };

            return {
                ...state,
                reviewsByProductId: {
                    ...state.reviewsByProductId,
                    [productId]: {
                        ...currentProductState,
                        loading: true,
                        error: null,
                    }
                }
            };
        }

        case REVIEWS_ACTION_TYPES.FETCH_LIST_SUCCESS: {
            const { productId, data, page, hasMore, totalReviews } = action.payload;
            const { byId: newById, allIds: newIds } = normalizeItems(data);

            const isFirstPage = page === 1;
            const existingProductState = state.reviewsByProductId[productId];

            let updatedIds;
            if (isFirstPage) {
                updatedIds = newIds;
            } else {
                const existingIds = existingProductState.ids || [];
                const uniqueNewIds = newIds.filter(id => !existingIds.includes(id));
                updatedIds = [...existingIds, ...uniqueNewIds];
            }

            return {
                ...state,
                byId: mergeNormalizedData(state.byId, newById),

                reviewsByProductId: {
                    ...state.reviewsByProductId,
                    [productId]: {
                        ...existingProductState,
                        loading: false,
                        ids: updatedIds,
                        currentPage: page,
                        hasMore: hasMore,
                        total: totalReviews,
                        error: null,
                    }
                }
            };
        }

        case REVIEWS_ACTION_TYPES.FETCH_LIST_FAILURE: {
            const { productId, error } = action.payload;
            return {
                ...state,
                reviewsByProductId: {
                    ...state.reviewsByProductId,
                    [productId]: {
                        ...state.reviewsByProductId[productId],
                        loading: false,
                        error: error,
                    }
                }
            };
        }

        default:
            return state;
    }
};